{
  "settings": {
    "sections": {
      "booking": {
        "label": "الحجز عبر الإنترنت",
        "hint": "حجز المرضى بأنفسهم، وأيام إجازتك، في كل عيادة"
      }
    },
    "onlineBooking": {
      "regionLabel": "الحجز عبر الإنترنت في عياداتك",
      "cardSubtitle": "حجز المرضى بأنفسهم في تطبيق المريض وعلى صفحتك",
      "unnamedClinic": "عيادة بلا اسم",
      "loadFailed": "إعدادات الحجز عبر الإنترنت غير متاحة.",
      "saved": "تم حفظ إعداد الحجز عبر الإنترنت.",
      "saveFailed": "لم يُحفظ الإعداد؛ حاول مرة أخرى.",
      "allow": {
        "label": "يمكن للمرضى الحجز عبر الإنترنت بأنفسهم",
        "impact": "عند الإيقاف لا تُعرض لك في هذه العيادة أوقات للحجز عبر الإنترنت في تطبيق المريض ولا على صفحتك. لا يتغيّر الحجز من قِبل الاستقبال."
      },
      "horizon": {
        "label": "حتى كم يومًا مقبلًا",
        "unit": "يوم",
        "placeholder": "حدّ العيادة نفسه",
        "clinicCap": "حدّ العيادة: {{days}} يوم",
        "effective": "يمكن للمرضى الآن الحجز حتى {{days}} يوم من الآن.",
        "effectiveNone": "بحدّ العيادة الحالي لا يمكن للمرضى الحجز عبر الإنترنت حاليًا.",
        "capped": "رقمك أكبر من حدّ العيادة، لذا يُطبَّق حدّ العيادة وهو {{days}} يوم.",
        "paused": "حجزك عبر الإنترنت في هذه العيادة متوقف.",
        "invalid": "أدخل رقمًا من ١ إلى ٣٦٥، أو اتركه فارغًا ليُطبَّق حدّ العيادة."
      },
      "warnings": {
        "noPresence": "لم تُسجَّل ساعات حضورك في هذه العيادة؛ لذلك لا يُعرض الحجز عبر الإنترنت.",
        "noPresenceHint": "يسجّل استقبال العيادة ساعات حضورك.",
        "clinicClosed": "هذه العيادة لا تقبل حجوزات المرضى عبر الإنترنت حاليًا.",
        "clinicClosedHint": "يُطبَّق إعدادك عندما تفعّل العيادة الحجز عبر الإنترنت."
      },
      "empty": {
        "title": "لست عضوًا في أي عيادة",
        "hint": "يُضبط الحجز عبر الإنترنت للعيادات التي قُبلت عضويتك فيها.",
        "action": "الانتقال إلى العيادات"
      },
      "daysOff": {
        "title": "أيام الإجازة",
        "hint": "في هذه الأيام لا يمكن للمرضى ولا للاستقبال حجز موعد لك في هذه العيادة. لا تتغيّر المواعيد المحجوزة مسبقًا.",
        "add": "إضافة يوم إجازة",
        "empty": "لا توجد أيام إجازة قادمة.",
        "emptyHint": "سجّل الأيام التي تغيب فيها — سفر أو مؤتمر أو مرض.",
        "loadFailed": "أيام الإجازة غير متاحة.",
        "wholeDay": "اليوم كله",
        "hours": "{{start}} إلى {{end}}",
        "range": "{{from}} إلى {{to}}",
        "remove": "حذف",
        "removeAria": "حذف الإجازة {{range}}",
        "removeTitle": "حذف يوم الإجازة",
        "removeBody": "هل تريد حذف الإجازة {{range}} في «{{clinic}}»؟ بعد الحذف يمكن حجز مواعيد لك في هذه الأيام مجددًا.",
        "removeConfirm": "احذف",
        "removed": "تم حذف يوم الإجازة.",
        "removeFailed": "لم يُحذف يوم الإجازة."
      },
      "dayOff": {
        "title": "إضافة يوم إجازة",
        "subtitle": "في «{{clinic}}»",
        "from": "من تاريخ",
        "to": "إلى تاريخ (اختياري)",
        "toHint": "اتركه فارغًا لتسجيل ذلك اليوم وحده.",
        "span": "المدة",
        "spanWhole": "اليوم كله",
        "spanPart": "جزء من اليوم",
        "start": "من الساعة",
        "end": "إلى الساعة",
        "partHint": "تُطبَّق هذه الساعات على كل أيام الفترة.",
        "reason": "السبب (اختياري)",
        "reasonPlaceholder": "مثلًا مؤتمر",
        "submit": "تسجيل الإجازة",
        "saveFailed": "لم يُسجَّل يوم الإجازة.",
        "errors": {
          "from": "اختر تاريخ البداية.",
          "order": "لا يمكن أن يسبق تاريخ النهاية تاريخ البداية.",
          "range": "لا تتجاوز الإجازة ٣٦٦ يومًا.",
          "past": "لا يمكن أن تنتهي الإجازة قبل اليوم.",
          "hours": "يجب أن تسبق ساعة البداية ساعة النهاية."
        }
      }
    }
  },
  "errors": {
    "bff": {
      "onboarding": {
        "clinicListUnavailable": "قائمة العيادات غير متاحة."
      },
      "onlineBooking": {
        "notMember": "لست عضوًا مقبولًا في هذه العيادة.",
        "settingsLoad": "تعذّر تحميل إعدادات الحجز عبر الإنترنت.",
        "settingsSave": "تعذّر حفظ إعدادات الحجز عبر الإنترنت.",
        "horizonInvalid": "يجب أن يكون عدد الأيام من ١ إلى ٣٦٥؛ اتركه فارغًا لحدّ العيادة.",
        "invalid": "البيانات المُدخلة غير صالحة.",
        "daysOffLoad": "تعذّر تحميل أيام الإجازة.",
        "dayOffSave": "تعذّر تسجيل يوم الإجازة.",
        "dayOffRemove": "تعذّر حذف يوم الإجازة.",
        "dayOffNotFound": "لم يُعثر على يوم الإجازة هذا.",
        "dayOffDate": "تاريخ الإجازة غير صالح.",
        "dayOffOrder": "لا يمكن أن يسبق تاريخ نهاية الإجازة تاريخ بدايتها.",
        "dayOffRange": "لا تتجاوز الإجازة ٣٦٦ يومًا.",
        "dayOffPast": "لا يمكن أن تنتهي الإجازة قبل اليوم.",
        "dayOffMinutes": "يجب أن تسبق ساعة بداية الإجازة ساعة نهايتها."
      }
    }
  }
}
